import React from 'react';
import moment from 'moment';
import { Client } from '../../Client';
import AddAppointment from '../Appointments/AddAppointment';

import 'bootstrap-daterangepicker/daterangepicker.css';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import BigCalendar from 'react-big-calendar';
import './AppointmentsContainer.css';
import { Emoji } from 'emoji-mart'
import 'emoji-mart/css/emoji-mart.css'

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));



function CustomToolbar(toolbar) {
	const goPrev = () => { toolbar.onNavigate('PREV'); };
	const goNext = () => { toolbar.onNavigate('NEXT'); };
	const label = () => {
		const date = moment(toolbar.date);
		return (
			<span><b>{date.format('MMMM')}</b> <span>{date.format('YYYY')}</span></span>
		);
	};

	return (
		<div className="toolbar-container text-center" style={{marginBottom: `10px`}}>

			<div className="back-next-buttons">
				<button className="btn btn-sm btn-secondary" onClick={goPrev}><i className="fa fa-chevron-left"></i></button>
				<label className='label-date' style={{marginLeft: `10px`, marginRight: `10px`}}>{label()}</label>
				<button className="btn btn-sm btn-secondary" onClick={goNext}><i className="fa fa-chevron-right"></i></button>
			</div>

			<div className="filter-container">

			</div>
		</div>
	)
}


function EmojiEvent(event) {
	return (
		<div className="event-emoji text-center">
			<Emoji emoji={{id: event.title, skin: 1}} size={64} set="facebook"/>
		</div>
	)
}


class AppointmentsContainer extends React.Component {
	state = {
		isAddAppointmentOpen: false,
	    appointments: [],
	    selectedAppointment: [],
	};

	componentDidMount() {
		this.loadAppointments();
	}

	loadAppointments = () => {
		Client.getAppointments((serverApts) => {
			// console.log(serverApts);

			let appointments = serverApts.map((apt) => {
				// For use with Big Calendar
				apt['start'] = new Date(apt['start_date']);
				apt['end'] = new Date(apt['end_date']);
				return apt;
			});

			this.setState({ appointments: appointments })
		});
	};


	eventStyleGetter = (event, start, end, isSelected) => {
		// console.log(event);
		// var backgroundColor = event.label;
		var style;
		var style1 = {
			backgroundColor: 'transparent',
			borderRadius: '0px',
			opacity: 1,
			border: '0px',
			display: 'block'
		};
		var style2 = {
			backgroundColor: 'transparent',
			borderRadius: '0px',
			opacity: 1,
			border: '0px',
			display: 'block'
		};

		if (isSelected) style = style2
		else style = style1
		return {
			style: style,
		};
	};



	handleEventClick = (slotInfo) => {
		// console.log("Slot");
		// console.log(slotInfo);
		this.setState({ 
			selectedAppointment: {
				id: slotInfo._id,
				contact_id: slotInfo.contact_id,
				title: slotInfo.title,
				emoji: slotInfo.emoji,
				start_date: slotInfo.start,
				end_date: slotInfo.end,
				description: slotInfo.description,
				appointment_type: slotInfo.appointment_type,
			},
			isAddAppointmentOpen: true
		});
	};


	handleSlotClick = (slotInfo) => {
		// console.log(slotInfo);
		this.setState({ 
			selectedAppointment: {
				start_date: slotInfo.start,
				end_date: slotInfo.end,
			},
			isAddAppointmentOpen: true
		});
	};


	handleModalOpen = (type) => {
		if (type === 'add_appointment') {
			this.setState({ 
				selectedAppointment: [],
				isAddAppointmentOpen: true,
			});
		}
	};

	handleAppointmentDelete = (aptId) => {
		// console.log("Delete", aptId);
		// console.log(this.state.appointments)

		this.setState({
			appointments: this.state.appointments.filter(c => c._id !== aptId),
		});
		Client.delete('/api/crm/appointments', { id: aptId });
	};


	handleModalClose = () => {
		this.setState({
			isAddAppointmentOpen: false,
		});
	};



	handleAddAppointmentSubmit = (apt) => {
		// For creation, wait for callback to get _id (key) from API
		// console.log(apt);
		apt.title = apt.emoji;
		if (apt.id) {		// If an update
			// console.log("Update");
			Client.put('/api/crm/appointments', apt, (ret) => {
				// console.log("Saved...");
				this.updateAppointment(apt);
			});
		}
		else {					// If an insert
			// console.log("Insert");
			Client.createAppointment(apt, (res) => {
				apt._id = res._id;
				this.insertAppointment(apt);
			});
		}
	};





	insertAppointment(apt) {
		apt['start'] = new Date(apt['start_date']);
		apt['end'] = new Date(apt['end_date']);
		this.setState({
			appointments: this.state.appointments.concat(apt),
		});
	}

	// Update local store
	updateAppointment(apt) {
		// console.log(apt);
		this.setState({
			appointments: this.state.appointments.map((aptUpdated) => {
				if (aptUpdated._id === apt.id) {
					return Object.assign({}, aptUpdated, {
						id: apt._id,
						contact_id: apt.contact_id,
						title: apt.title,
						emoji: apt.emoji,
						start_date: apt.start_date,
						end_date: apt.end_date,
						description: apt.description,
						appointment_type: apt.appointment_type,
						updated_at: apt.updated_at,
						created_at: apt.created_at,
						start: new Date(apt.start_date),
						end: new Date(apt.end_date),
					});
				} else {
					return aptUpdated;
				}
			}), 
		});
	};



	render() {
		var addAppointmentForm;
		if (this.state.isAddAppointmentOpen === true) {
			addAppointmentForm = <AddAppointment 
				id={this.state.selectedAppointment.id}
				contact_id={this.state.selectedAppointment.contact_id}
				title={this.state.selectedAppointment.title}
				start_date={this.state.selectedAppointment.start_date}
				end_date={this.state.selectedAppointment.end_date}
				description={this.state.selectedAppointment.description}
				appointment_type={this.state.selectedAppointment.appointment_type}
				onDelete={this.handleAppointmentDelete}
				onSubmit={this.handleAddAppointmentSubmit}
				onClose={this.handleModalClose}
				/>
		}


		return (
			<div className="container container-calendar">

				<div className="card">
					<div className="card-block">

						<h4 style={{marginBottom: 30 + "px"}}><i className="fa fa-smile-o "></i>  Emoji Journal</h4>
						<p>Click/Tap on a day to show how you're feeling</p>

						<div style={{height: 600 + 'px'}}>
							<BigCalendar
							components={{
								event: EmojiEvent,
								toolbar: CustomToolbar
							}}
							
							selectable
							events={this.state.appointments}
							views={['month']}
						    culture="en-GB"
							eventPropGetter={(this.eventStyleGetter)}
							onSelectEvent={(event) => this.handleEventClick(event)}
							onSelectSlot={(slotInfo) => this.handleSlotClick(slotInfo)}
							/>
						</div>

						{addAppointmentForm}

					</div>
				</div>
			</div>



		);
	}
}




export default AppointmentsContainer;




// WEBPACK FOOTER //
// ./src/js/components/containers/AppointmentsContainer.js